import Button from "@components/library/Button";
import { useMonitoringFile } from "@/context/MonitoringFileContext";
import { DataDisplay } from "../Drawers/DataDisplay";
import { ArrowRightIcon } from "@components/library/Icons";
import IconButton from "@components/library/IconButton";
import { Tooltip } from "@components/library/Tooltip";
import { Dataset } from "@/types/app/dataset";
import { AttributeDetails } from "./AttributeDetails";
import { useAppHref } from "@/lib/path-utils";

export const DatasetVersionDetails = ({ dataset }: { dataset: Dataset }) => {
  const datapointsHref =
    useAppHref({
      id: dataset.id,
      page: "editor",
      type: "file",
    }) + `/${dataset.version_id}`;
  return (
    <div className="flex flex-col gap-24">
      <div className="flex flex-col gap-12">
        <DataDisplay
          label="Datapoints"
          value={
            <div className="flex items-center gap-6">
              <span className="tabular-nums">{dataset.datapoints_count}</span>
              <Tooltip content="View Datapoints">
                <IconButton href={datapointsHref} shade="gray" Icon={ArrowRightIcon} size={20} />
              </Tooltip>
            </div>
          }
        />
      </div>
      <div className="flex w-full flex-col text-text-base-1">
        <Button elevated size={40} styling="outline" IconRight={ArrowRightIcon} href={datapointsHref}>
          View Dataset in Editor
        </Button>
      </div>
      <AttributeDetails {...dataset} />
    </div>
  );
};
